<template>
    <div class="sidebar p-2 py-md-3 " v-bind:class="{ 'document': $route.meta.domain == 'documentation' }" id="sidebar">
        <div class="container-fluid">
            <div class="title-text d-flex align-items-center mb-4 mt-1">
                <h4 class="sidebar-title mb-0 flex-grow-1"><span class="sm-txt">V</span><span>ila Bogor Indah 6</span></h4>
            </div>
            <div v-if="$route.meta.domain != 'documentation'">
                <!-- sidebar: menu list -->
                <div class="main-menu flex-grow-1" v-if="$route.meta.domain == 'Admin'">
                    <ul class="menu-list">
                        <li class="collapsed" :class="{'h_none': (item.menu == 'RESOURCES' || item.menu == 'Layouts' || item.menu == 'Modals Popups' || item.menu == 'Widgets' || item.menu == 'Documentation' || item.menu == 'Changelog') ,'divider py-2 lh-sm': item.menu =='RESOURCES'}" v-for="(item,index) in sidebarMenuItems" :key="item">
                            <template  v-if="item.sub && item.menu !='Menu Level 0'">
                                <!-- v-bind:class="{ show: item.menu] == currentTab }" -->
                                <router-link to="#" class="m-link" v-bind:class="{ active: item.menu == currentTab }" data-bs-toggle="collapse" :data-bs-target="'#menu'+index" :aria-expanded="item.menu == currentTab">
                                    <span v-html="item.svg" class="d-block"></span>
                                    <span class="ms-3">{{item.menu}}</span>
                                    <span class="arrow fa fa-angle-right ms-auto text-end"></span>
                                </router-link>
                                <!-- Menu: Sub menu ul -->
                                <ul class='sub-menu collapse' v-bind:class="{ show: item.menu == currentTab }" :id="'menu'+index">
                                    <li v-for="subItem in item.sub" :key="subItem" >
                                        <router-link v-bind:class="{ active: currentRoutePath == subItem.name }" :to="{ name: subItem.name}" class="ms-link" @click="hideSidebar()">{{subItem.name}}</router-link>
                                    </li>
                                </ul>
                            </template>
                            <template  v-else-if="item.sub && item.menu =='Menu Level 0'">
                                <a class="m-link" data-bs-toggle="collapse" data-bs-target="#menu-level0" href="#">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" fill="currentColor" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6 3.5C6 3.10218 6.15804 2.72064 6.43934 2.43934C6.72064 2.15804 7.10218 2 7.5 2H8.5C8.89782 2 9.27936 2.15804 9.56066 2.43934C9.84196 2.72064 10 3.10218 10 3.5V4.5C10 4.89782 9.84196 5.27936 9.56066 5.56066C9.27936 5.84196 8.89782 6 8.5 6V7H14C14.1326 7 14.2598 7.05268 14.3536 7.14645C14.4473 7.24021 14.5 7.36739 14.5 7.5V8.5C14.5 8.63261 14.4473 8.75979 14.3536 8.85355C14.2598 8.94732 14.1326 9 14 9C13.8674 9 13.7402 8.94732 13.6464 8.85355C13.5527 8.75979 13.5 8.63261 13.5 8.5V8H8.5V8.5C8.5 8.63261 8.44732 8.75979 8.35355 8.85355C8.25979 8.94732 8.13261 9 8 9C7.86739 9 7.74021 8.94732 7.64645 8.85355C7.55268 8.75979 7.5 8.63261 7.5 8.5V8H2.5V8.5C2.5 8.63261 2.44732 8.75979 2.35355 8.85355C2.25979 8.94732 2.13261 9 2 9C1.86739 9 1.74021 8.94732 1.64645 8.85355C1.55268 8.75979 1.5 8.63261 1.5 8.5V7.5C1.5 7.36739 1.55268 7.24021 1.64645 7.14645C1.74021 7.05268 1.86739 7 2 7H7.5V6C7.10218 6 6.72064 5.84196 6.43934 5.56066C6.15804 5.27936 6 4.89782 6 4.5V3.5Z" />
                                    <path class="fill-secondary" d="M0.43934 10.4393C0.158035 10.7206 0 11.1022 0 11.5V12.5C0 12.8978 0.158035 13.2794 0.43934 13.5607C0.720644 13.842 1.10218 14 1.5 14H2.5C2.89782 14 3.27936 13.842 3.56066 13.5607C3.84196 13.2794 4 12.8978 4 12.5V11.5C4 11.1022 3.84196 10.7206 3.56066 10.4393C3.27936 10.158 2.89782 10 2.5 10H1.5C1.10218 10 0.720644 10.158 0.43934 10.4393Z" />
                                    <path class="fill-secondary" d="M6.43934 10.4393C6.15804 10.7206 6 11.1022 6 11.5V12.5C6 12.8978 6.15804 13.2794 6.43934 13.5607C6.72064 13.842 7.10218 14 7.5 14H8.5C8.89782 14 9.27936 13.842 9.56066 13.5607C9.84196 13.2794 10 12.8978 10 12.5V11.5C10 11.1022 9.84196 10.7206 9.56066 10.4393C9.27936 10.158 8.89782 10 8.5 10H7.5C7.10218 10 6.72064 10.158 6.43934 10.4393Z" />
                                    <path class="fill-secondary" d="M12.4393 10.4393C12.158 10.7206 12 11.1022 12 11.5V12.5C12 12.8978 12.158 13.2794 12.4393 13.5607C12.7206 13.842 13.1022 14 13.5 14H14.5C14.8978 14 15.2794 13.842 15.5607 13.5607C15.842 13.2794 16 12.8978 16 12.5V11.5C16 11.1022 15.842 10.7206 15.5607 10.4393C15.2794 10.158 14.8978 10 14.5 10H13.5C13.1022 10 12.7206 10.158 12.4393 10.4393Z" />
                                </svg>
                                <span class="ms-3">Menu Level 0</span>
                                <span class="arrow fa fa-angle-right ms-auto text-end"></span>
                                </a>
                                <!-- Menu: Sub menu ul -->
                                <ul class="sub-menu collapse" id="menu-level0">
                                    <li class="collapsed">
                                        <a class="m-link" data-bs-toggle="collapse" data-bs-target="#menu-level1" href="#"><span>Level 1</span> <span class="arrow fa fa-angle-right ms-auto text-end"></span></a>
                                        <!-- Menu: Sub menu ul -->
                                        <ul class="sub-menu collapse" id="menu-level1">
                                            <li class="collapsed">
                                                <a class="m-link" data-bs-toggle="collapse" data-bs-target="#menu-level2" href="#"><span>Level 2</span> <span class="arrow fa fa-angle-right ms-auto text-end"></span></a>
                                                <!-- Menu: Sub menu ul -->
                                                <ul class="sub-menu collapse" id="menu-level2">
                                                    <li><a class="ms-link" href="#">Level 3</a></li>
                                                </ul>
                                            </li>
                                            <li><a class="ms-link" href="#">Level 2</a></li>
                                        </ul>
                                    </li>
                                    <li><a class="ms-link" href="#">Level 1</a></li>
                                </ul>
                            </template>
                            <template v-else-if="item.menu =='RESOURCES'">
                                <span class="small">{{item.menu}}</span>
                            </template>
                            <template v-else>
                                <router-link class="m-link" :to="{ name: item.menu}" v-bind:class="{ active: item.menu == currentTab }" @click="hideSidebar()">
                                    <span v-html="item.svg" class="d-block"></span>
                                    <span class="ms-3">{{item.menu}}</span>
                                    <span class="badge bg-primary ms-auto" v-if="item.menu =='Changelog'">v1.0.0</span>
                                </router-link>
                            </template>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <!-- Modal: Create project -->
    <div class="modal fade" id="CreateNew" tabindex="-1">
        <div class="modal-dialog modal-dialog-vertical modal-dialog-scrollable">
            <div class="modal-content rounded-0">
                <div class="modal-header">
                    <h5 class="modal-title">Setup New Project</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="progress bg-transparent" style="height: 3px;">
                    <div class="progress-bar bg-primary" role="progressbar" aria-valuenow="1" aria-valuemin="1" aria-valuemax="5" style="width: 20%;"></div>
                </div>
                <div class="modal-body custom_scroll">
                    <ul class="nav nav-tabs tab-card border-0 fs-6" role="tablist">
                        <li class="nav-item flex-fill text-center"><router-link class="nav-link active" to="#step1" data-bs-toggle="tab" data-bs-step="1">1. Project</router-link></li>
                        <li class="nav-item flex-fill text-center"><router-link class="nav-link" to="#step2" data-bs-toggle="tab" data-bs-step="3">2. Team</router-link></li>
                        <li class="nav-item flex-fill text-center"><router-link class="nav-link" to="#step3" data-bs-toggle="tab" data-bs-step="4">3. File</router-link></li>
                        <li class="nav-item flex-fill text-center"><router-link class="nav-link" to="#step4" data-bs-toggle="tab" data-bs-step="5">4. Completed</router-link></li>
                    </ul>
                    <div class="tab-content">
                        <!-- tab: Project -->
                        <div class="tab-pane fade show active" id="step1">
                            <div class="card mb-2">
                                <div class="card-body">
                                    <h6 class="card-title mb-1">Project Type</h6>
                                    <p class="text-muted small">If you need more info, please check out <router-link to="#">FAQ Page</router-link></p>
                                    <!-- Custome redio input -->
                                    <div class="c_radio d-flex flex-md-wrap">
                                        <label class="m-1 w-100" for="Personal">
                                        <input type="radio" name="plan" id="Personal" checked />
                                        <span class="card">
                                            <span class="card-body d-flex p-3">
                                            <svg class="avatar" viewBox="0 0 16 16">
                                                <path class="fill-muted" d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                                            </svg>
                                            <span class="ms-3">
                                                <span class="h6 d-flex mb-1">Personal Project</span>
                                                <span class="text-muted">For smaller business, with simple salaries and pay schedules.</span>
                                            </span>
                                            </span>
                                        </span>
                                        </label>
                                        <label class="m-1 w-100" for="Team">
                                        <input type="radio" name="plan" id="Team" />
                                        <span class="card">
                                            <span class="card-body d-flex p-3">
                                                <svg class="avatar" viewBox="0 0 16 16">
                                                    <path class="fill-muted" d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                                                    <path class="fill-muted" fill-rule="evenodd" d="M5.216 14A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216z" />
                                                    <path class="fill-muted" d="M4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z" />
                                                </svg>
                                                <span class="ms-3">
                                                    <span class="h6 d-flex mb-1">Team Project</span>
                                                    <span class="text-muted">For growing business who wants to create a rewarding place to work.</span>
                                                </span>
                                            </span>
                                        </span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="card mb-2">
                                <div class="card-body">
                                    <h6 class="card-title mb-1">Project Details</h6>
                                    <p class="text-muted small">It is a long established fact that a reader will be distracted by Luno.</p>
                                    <div class="form-floating mb-2">
                                        <select class="form-select">
                                        <option selected>Open this select menu</option>
                                        <option value="1">Lucid</option>
                                        <option value="2">Luno</option>
                                        <option value="3">Luno</option>
                                        </select>
                                        <label>Choose a Customer *</label>
                                    </div>
                                    <div class="form-floating mb-2">
                                        <input type="text" class="form-control" placeholder="Project name">
                                        <label>Project name *</label>
                                    </div>
                                    <div class="form-floating mb-2">
                                        <textarea class="form-control" placeholder="Add project details" style="height: 100px"></textarea>
                                        <label>Add project details</label>
                                    </div>
                                    <div class="form-floating mb-2">
                                        <datepicker class="form-control" v-model="picked.date"  :enable-time-picker="false" auto-apply></datepicker>
                                        <label>Enter release Date *</label>
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <div class="text-muted">Allow Notifications *</div>
                                        <div>
                                            <div class="form-check form-check-inline">
                                                <input class="form-check-input" type="checkbox" id="allow_phone" value="option1">
                                                <label class="form-check-label" for="allow_phone">Phone</label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                                <input class="form-check-input" type="checkbox" id="allow_email" value="option2">
                                                <label class="form-check-label" for="allow_email">Email</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="text-center">
                                <button class="btn btn-lg bg-secondary text-light next text-uppercase">Add People</button>
                            </div>
                        </div>
                        <!-- tab: Select Team -->
                        <div class="tab-pane fade" id="step2">
                            <div class="card mb-3">
                                <div class="card-body">
                                    <h6 class="card-title mb-1">Build a Team</h6>
                                    <p class="text-muted small">If you need more info, please check out <router-link to="#">Project Guidelines</router-link></p>
                                    <div class="form-floating mb-4">
                                        <input type="text" class="form-control" placeholder="Invite Teammates">
                                        <label>Invite Teammates</label>
                                    </div>
                                    <h6 class="card-title mb-1">Team Members</h6>
                                    <div class="form-check form-switch">
                                        <input class="form-check-input" type="checkbox" id="list-group6" checked="">
                                        <label class="form-check-label text-muted" for="list-group6">Adding Users by Team Members</label>
                                    </div>
                                </div>
                                <ul class="list-group list-group-flush list-group-custom custom_scroll mb-0" style="height: 300px;">
                                    <li class="list-group-item d-flex align-items-center">
                                        <img class="avatar rounded" src="../../assets/img/xs/avatar1.jpg" alt="">
                                        <div class="flex-fill ms-2">
                                            <div class="h6 mb-0">Chris Fox</div>
                                            <small class="text-muted">Angular Developer</small>
                                        </div>
                                        <select class="form-select rounded-pill form-select-sm w120">
                                            <option value="1">Owner</option>
                                            <option value="2">Can Edit</option>
                                            <option value="3">Guest</option>
                                        </select>
                                    </li>
                                    <li class="list-group-item d-flex align-items-center">
                                        <img class="avatar rounded" src="../../assets/img/xs/avatar2.jpg" alt="">
                                        <div class="flex-fill ms-2">
                                            <div class="h6 mb-0">Joge Lucky</div>
                                            <small class="text-muted">ReactJs Developer</small>
                                        </div>
                                        <select class="form-select rounded-pill form-select-sm w120">
                                            <option value="1">Owner</option>
                                            <option value="2">Can Edit</option>
                                            <option value="3">Guest</option>
                                        </select>
                                    </li>
                                    <li class="list-group-item d-flex align-items-center">
                                        <img class="avatar rounded" src="../../assets/img/xs/avatar3.jpg" alt="">
                                        <div class="flex-fill ms-2">
                                            <div class="h6 mb-0">Chris Fox</div>
                                            <small class="text-muted">NodeJs Developer</small>
                                        </div>
                                        <select class="form-select rounded-pill form-select-sm w120">
                                            <option value="1">Owner</option>
                                            <option value="2">Can Edit</option>
                                            <option value="3">Guest</option>
                                        </select>
                                    </li>
                                    <li class="list-group-item d-flex align-items-center">
                                        <img class="avatar rounded" src="../../assets/img/xs/avatar4.jpg" alt="">
                                        <div class="flex-fill ms-2">
                                            <div class="h6 mb-0">Chris Fox</div>
                                            <small class="text-muted">Sr. Designer</small>
                                        </div>
                                        <select class="form-select rounded-pill form-select-sm w120">
                                            <option value="1">Owner</option>
                                            <option value="2">Can Edit</option>
                                            <option value="3">Guest</option>
                                        </select>
                                    </li>
                                    <li class="list-group-item d-flex align-items-center">
                                        <img class="avatar rounded" src="../../assets/img/xs/avatar5.jpg" alt="">
                                        <div class="flex-fill ms-2">
                                            <div class="h6 mb-0">Chris Fox</div>
                                            <small class="text-muted">Designer</small>
                                        </div>
                                        <select class="form-select rounded-pill form-select-sm w120">
                                            <option value="1">Owner</option>
                                            <option value="2">Can Edit</option>
                                            <option value="3">Guest</option>
                                        </select>
                                    </li>
                                    <li class="list-group-item d-flex align-items-center">
                                        <img class="avatar rounded" src="../../assets/img/xs/avatar6.jpg" alt="">
                                        <div class="flex-fill ms-2">
                                            <div class="h6 mb-0">Chris Fox</div>
                                            <small class="text-muted">Front-End Developer</small>
                                        </div>
                                        <select class="form-select rounded-pill form-select-sm w120">
                                            <option value="1">Owner</option>
                                            <option value="2">Can Edit</option>
                                            <option value="3">Guest</option>
                                        </select>
                                    </li>
                                    <li class="list-group-item d-flex align-items-center">
                                        <img class="avatar rounded" src="../../assets/img/xs/avatar7.jpg" alt="">
                                        <div class="flex-fill ms-2">
                                            <div class="h6 mb-0">Chris Fox</div>
                                            <small class="text-muted">QA</small>
                                        </div>
                                        <select class="form-select rounded-pill form-select-sm w120">
                                            <option value="1">Owner</option>
                                            <option value="2">Can Edit</option>
                                            <option value="3">Guest</option>
                                        </select>
                                    </li>
                                    <li class="list-group-item d-flex align-items-center">
                                        <img class="avatar rounded" src="../../assets/img/xs/avatar8.jpg" alt="">
                                        <div class="flex-fill ms-2">
                                            <div class="h6 mb-0">Chris Fox</div>
                                            <small class="text-muted">Laravel Developer</small>
                                        </div>
                                        <select class="form-select rounded-pill form-select-sm w120">
                                            <option value="1">Owner</option>
                                            <option value="2">Can Edit</option>
                                            <option value="3">Guest</option>
                                        </select>
                                    </li>
                                </ul>
                            </div>
                            <div class="text-center">
                                <button class="btn btn-lg bg-secondary text-light next text-uppercase">Select Files</button>
                            </div>
                        </div>
                        <!-- tab: Select File -->
                        <div class="tab-pane fade" id="step3">
                            <div class="card mb-3">
                                <div class="card-body">
                                    <h6 class="card-title mb-1">Upload Files</h6>
                                    <div class="mb-4">
                                        <label class="form-label small">Upload up to 10 files</label>
                                        <input class="form-control" type="file" multiple>
                                    </div>
                                    <span>Already Uploaded File</span>
                                </div>
                                <ul class="list-group list-group-flush list-group-custom custom_scroll mb-0" style="height: 300px;">
                                    <li class="list-group-item d-flex align-items-center">
                                        <div class="avatar rounded no-thumbnail"><i class="fa fa-file-pdf-o text-danger"></i></div>
                                        <div class="flex-fill ms-3 text-truncate">
                                            <p class="mb-0 color-800">Annual Sales Report 2018-19</p>
                                            <small class="text-muted">.pdf, 5.3 MB</small>
                                        </div>
                                    </li>
                                    <li class="list-group-item d-flex align-items-center">
                                        <div class="avatar rounded no-thumbnail"><i class="fa fa-file-excel-o text-success"></i></div>
                                        <div class="flex-fill ms-3 text-truncate">
                                            <p class="mb-0 color-800">Complete Product Sheet</p>
                                            <small class="text-muted">.xls, 2.1 MB</small>
                                        </div>
                                    </li>
                                    <li class="list-group-item d-flex align-items-center">
                                        <div class="avatar rounded no-thumbnail"><i class="fa fa-file-word-o text-info"></i></div>
                                        <div class="flex-fill ms-3 text-truncate">
                                            <p class="mb-0 color-800">Marketing Guidelines</p>
                                            <small class="text-muted">.doc, 2.3 MB</small>
                                        </div>
                                    </li>
                                    <li class="list-group-item d-flex align-items-center">
                                        <div class="avatar rounded no-thumbnail"><i class="fa fa-file-zip-o"></i></div>
                                        <div class="flex-fill ms-3 text-truncate">
                                            <p class="mb-0 color-800">Brand Photography</p>
                                            <small class="text-muted">.zip, 30.5 MB</small>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div class="text-center">
                                <button class="btn btn-lg bg-secondary text-light next text-uppercase">Advanced Options</button>
                            </div>
                        </div>
                        <!-- tab: Completed -->
                        <div class="tab-pane fade" id="step4">
                            <div class="card text-center">
                                <div class="card-body">
                                    <h4 class="card-title mb-1">Project Created!</h4>
                                    <span class="text-muted">If you need more info, please check how to create project</span>
                                </div>
                                <div class="card-body">
                                    <button class="btn btn-lg bg-light first text-uppercase">Cretae new project</button>
                                    <button class="btn btn-lg bg-secondary text-light text-uppercase">View project</button>
                                </div>
                                <div class="card-body">
                                    <img class="img-fluid" src="../../assets/img/project-team.svg" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Modal: my notes -->
    <div class="modal fade" id="MynotesModal" tabindex="-1">
        <div class="modal-dialog modal-dialog-vertical modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header px-4">
            <h5 class="modal-title">My Notes <span class="badge bg-danger ms-2">14</span></h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="bg-light px-4 py-3">
            <ul class="nav nav-pills nav-fill" role="tablist">
                <li class="nav-item">
                <a class="nav-link active" data-bs-toggle="tab" href="#Notetab-all" role="tab" aria-selected="true">All Notes</a>
                </li>
                <li class="nav-item">
                <a class="nav-link" data-bs-toggle="tab" href="#Notetab-Business" role="tab" aria-selected="false">Business</a>
                </li>
                <li class="nav-item">
                <a class="nav-link" data-bs-toggle="tab" href="#Notetab-Social" role="tab">Social</a>
                </li>
                <li class="nav-item">
                <a class="nav-link" data-bs-toggle="tab" href="#Notetab-Create" role="tab"><i class="fa fa-plus me-2"></i>New</a>
                </li>
            </ul>
            </div>
            <div class="modal-body px-4 custom_scroll">
            <div class="tab-content p-0">
                <div class="tab-pane fade active show" id="Notetab-all" role="tabpanel">
                <div class="card border ribbon mb-2">
                    <div class="option-2 bg-primary position-absolute"></div>
                    <div class="card-body">
                    <span class="text-muted small">02 January 2021</span>
                    <p class="lead">Give Review for design</p>
                    <span>It has roots in a piece of classical Latin literature from 45 BC, making it over 2020 years old.</span>
                    </div>
                    <div class="card-footer pt-0 border-0">
                    <a class="btn btn-sm btn-outline-secondary mx-1" href="#"><i class="fa fa-star favourite-note"></i></a>
                    <a class="btn btn-sm btn-outline-secondary mx-1" href="#"><i class="fa fa-trash favourite-note"></i></a>
                    </div>
                </div>
                <div class="card border ribbon mb-2">
                    <div class="option-2 bg-success position-absolute"></div>
                    <div class="card-body">
                    <span class="text-muted small">17 January 2022</span>
                    <p class="lead">Give salary to employee</p>
                    <span>The generated Lorem Ipsum is therefore always free from repetition</span>
                    </div>
                    <div class="card-footer pt-0 border-0">
                    <a class="btn btn-sm btn-outline-secondary mx-1" href="#"><i class="fa fa-star favourite-note"></i></a>
                    <a class="btn btn-sm btn-outline-secondary mx-1" href="#"><i class="fa fa-trash favourite-note"></i></a>
                    </div>
                </div>
                <div class="card border ribbon mb-2">
                    <div class="option-2 bg-info position-absolute"></div>
                    <div class="card-body">
                    <span class="text-muted small">02 Fabruary 2020</span>
                    <p class="lead">Launch new template</p>
                    <span>Blandit tempus porttitor aasfs. Integer posuere erat a ante venenatis.</span>
                    </div>
                    <div class="card-footer pt-0 border-0">
                    <a class="btn btn-sm btn-outline-secondary mx-1" href="#"><i class="fa fa-star favourite-note"></i></a>
                    <a class="btn btn-sm btn-outline-secondary mx-1" href="#"><i class="fa fa-trash favourite-note"></i></a>
                    </div>
                </div>
                <div class="card border ribbon mb-2">
                    <div class="option-2 bg-dark position-absolute"></div>
                    <div class="card-body">
                    <span class="text-muted small">22 August 2021</span>
                    <p class="lead">Nightout with friends</p>
                    <span>Blandit tempus porttitor aasfs. Integer posuere erat a ante venenatis.</span>
                    </div>
                    <div class="card-footer pt-0 border-0">
                    <a class="btn btn-sm btn-outline-secondary mx-1" href="#"><i class="fa fa-star favourite-note"></i></a>
                    <a class="btn btn-sm btn-outline-secondary mx-1" href="#"><i class="fa fa-trash favourite-note"></i></a>
                    </div>
                </div>
                <div class="card border ribbon mb-2">
                    <div class="option-2 bg-danger position-absolute"></div>
                    <div class="card-body">
                    <span class="text-muted small">01 December 2021</span>
                    <p class="lead">Change a Design</p>
                    <span> It has survived not only five centuries, but also the leap into electronic</span>
                    </div>
                    <div class="card-footer pt-0 border-0">
                    <a class="btn btn-sm btn-outline-secondary mx-1" href="#"><i class="fa fa-star favourite-note"></i></a>
                    <a class="btn btn-sm btn-outline-secondary mx-1" href="#"><i class="fa fa-trash favourite-note"></i></a>
                    </div>
                </div>
                <div class="card border ribbon mb-2">
                    <div class="option-2 bg-warning position-absolute"></div>
                    <div class="card-body">
                    <span class="text-muted small">10 December 2021</span>
                    <p class="lead">Meeting with Mr.Lee</p>
                    <span>Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model</span>
                    </div>
                    <div class="card-footer pt-0 border-0">
                    <a class="btn btn-sm btn-outline-secondary mx-1" href="#"><i class="fa fa-star favourite-note"></i></a>
                    <a class="btn btn-sm btn-outline-secondary mx-1" href="#"><i class="fa fa-trash favourite-note"></i></a>
                    </div>
                </div>
                </div>
                <div class="tab-pane fade" id="Notetab-Business" role="tabpanel">
                <div class="card border ribbon mb-2">
                    <div class="option-2 bg-warning position-absolute"></div>
                    <div class="card-body">
                    <span class="text-muted small">10 December 2021</span>
                    <p class="lead">Meeting with Mr.Lee</p>
                    <span>Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model</span>
                    </div>
                    <div class="card-footer pt-0 border-0">
                    <a class="btn btn-sm btn-outline-secondary mx-1" href="#"><i class="fa fa-star favourite-note"></i></a>
                    <a class="btn btn-sm btn-outline-secondary mx-1" href="#"><i class="fa fa-trash favourite-note"></i></a>
                    </div>
                </div>
                <div class="card border ribbon mb-2">
                    <div class="option-2 bg-danger position-absolute"></div>
                    <div class="card-body">
                    <span class="text-muted small">01 December 2021</span>
                    <p class="lead">Change a Design</p>
                    <span> It has survived not only five centuries, but also the leap into electronic</span>
                    </div>
                    <div class="card-footer pt-0 border-0">
                    <a class="btn btn-sm btn-outline-secondary mx-1" href="#"><i class="fa fa-star favourite-note"></i></a>
                    <a class="btn btn-sm btn-outline-secondary mx-1" href="#"><i class="fa fa-trash favourite-note"></i></a>
                    </div>
                </div>
                </div>
                <div class="tab-pane fade" id="Notetab-Social" role="tabpanel">
                <div class="card border ribbon mb-2">
                    <div class="option-2 bg-dark position-absolute"></div>
                    <div class="card-body">
                    <span class="text-muted small">22 August 2021</span>
                    <p class="lead">Nightout with friends</p>
                    <span>Blandit tempus porttitor aasfs. Integer posuere erat a ante venenatis.</span>
                    </div>
                    <div class="card-footer pt-0 border-0">
                    <a class="btn btn-sm btn-outline-secondary mx-1" href="#"><i class="fa fa-star favourite-note"></i></a>
                    <a class="btn btn-sm btn-outline-secondary mx-1" href="#"><i class="fa fa-trash favourite-note"></i></a>
                    </div>
                </div>
                </div>
                <div class="tab-pane fade" id="Notetab-Create" role="tabpanel">
                <div class="form-floating mb-2">
                    <input type="text" class="form-control" placeholder="Note Title">
                    <label>Note Title</label>
                </div>
                <div class="form-floating mb-2">
                    <datepicker class="form-control" v-model="picked.date"  :enable-time-picker="false" auto-apply></datepicker>

                    <label>Select Date</label>
                </div>
                <div class="form-floating mb-2">
                    <select class="form-select" id="floatingSelect" aria-label="Floating label select example">
                    <option selected>Open this select menu</option>
                    <option value="1">Business</option>
                    <option value="2">Social</option>
                    </select>
                    <label>Works with selects</label>
                </div>
                <div class="form-floating mb-4">
                    <textarea class="form-control" placeholder="Leave a comment here" style="height: 100px"></textarea>
                    <label>Leave a comment here</label>
                </div>
                <button type="button" class="btn btn-primary lift mx-1">Save note</button>
                <button type="button" class="btn btn-white border lift mx-1" data-bs-dismiss="modal">Close</button>
                </div>
            </div>
            </div>
        </div>
        </div>
    </div>
    <!-- Modal: Schedule -->
    <div class="modal fade" id="ScheduleModal" tabindex="-1">
        <div class="modal-dialog modal-dialog-vertical modal-dialog-scrollable modal-sm">
        <div class="modal-content">
            <div class="modal-header bg-secondary rounded-0">
            <h5 class="modal-title text-light">Schedule</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body custom_scroll">
            <div class="ps-2">
                <!--Timeline item-->
                <div class="timeline-item ti-primary p-3">
                <div class="avatar sm rounded-circle-circle no-thumbnail">
                    <i class="fa fa-phone"></i>
                </div>
                <div class="timeline-content ms-3">
                    <div>Call Danny at Colby's</div>
                    <small class="text-muted">Today - 11:32am</small>
                </div>
                </div>
                <!--Timeline item-->
                <div class="timeline-item ti-info p-3">
                <div class="timeline-icon">
                    <img class="avatar sm rounded-circle" src="../../assets/img/xs/avatar1.jpg" alt="">
                </div>
                <div class="timeline-content ms-3">
                    <div>Meeting with Alice</div>
                    <small class="text-muted">Today - 12:50pm</small>
                </div>
                </div>
                <!--Timeline item-->
                <div class="timeline-item ti-danger p-3">
                <div class="avatar sm rounded-circle-circle no-thumbnail">
                    <i class="fa fa-comment"></i>
                </div>
                <div class="timeline-content ms-3">
                    <div>Answer Annie's message</div>
                    <small class="text-muted">Today - 01:35pm</small>
                </div>
                </div>
                <!--Timeline item-->
                <div class="timeline-item ti-danger p-3">
                <div class="avatar sm rounded-circle-circle no-thumbnail">
                    <i class="fa fa-phone"></i>
                </div>
                <div class="timeline-content ms-3">
                    <div>Send new campaign</div>
                    <small class="text-muted">Today - 02:40pm</small>
                </div>
                </div>
                <!--Timeline item-->
                <div class="timeline-item ti-primary p-3">
                <div class="avatar sm rounded-circle-circle no-thumbnail">
                    <i class="fa fa-smile-o"></i>
                </div>
                <div class="timeline-content ms-3">
                    <div>Project review</div>
                    <small class="text-muted">Today - 03:15pm</small>
                </div>
                </div>
                <!--Timeline item-->
                <div class="timeline-item ti-warning p-3">
                <div class="avatar sm rounded-circle-circle no-thumbnail">
                    <i class="fa fa-phone"></i>
                </div>
                <div class="timeline-content ms-3">
                    <div>Call Trisha Jackson</div>
                    <small class="text-muted">Today - 05:40pm</small>
                </div>
                </div>
                <!--Timeline item-->
                <div class="timeline-item ti-success p-3">
                <div class="avatar sm rounded-circle-circle no-thumbnail">
                    <i class="fa fa-leaf"></i>
                </div>
                <div class="timeline-content ms-3">
                    <div>Write proposal for Don</div>
                    <small class="text-muted">Today - 06:30pm</small>
                </div>
                </div>
            </div>
            </div>
        </div>
        </div>
    </div>
    <!-- Modal: RecentChat -->
    <div class="offcanvas offcanvas-end" id="RecentChat" tabindex="-1" style="width: 460px;">
        <div class="offcanvas-body d-flex align-items-start p-0">
        <div class="nav flex-column nav-pills p-3 h-100 order-1">
            <a class="nav-link rounded-circle p-1 mb-2 active" href="javascript:void(0);" data-bs-toggle="pill" data-bs-target="#c-user-1" title="">
            <img class="avatar sm rounded-circle border" src="../../assets/img/xs/avatar1.jpg" alt="avatar">
            </a>
            <a class="nav-link rounded-circle p-1 mb-2" href="javascript:void(0);" data-bs-toggle="pill" data-bs-target="#c-user-2" title="">
            <img class="avatar sm rounded-circle border" src="../../assets/img/xs/avatar2.jpg" alt="avatar">
            </a>
            <a class="nav-link rounded-circle p-1 mb-2" href="javascript:void(0);" data-bs-toggle="pill" data-bs-target="#c-user-1" title="">
            <img class="avatar sm rounded-circle border" src="../../assets/img/xs/avatar3.jpg" alt="avatar">
            </a>
            <a class="nav-link rounded-circle p-1 mb-2" href="javascript:void(0);" data-bs-toggle="pill" data-bs-target="#c-user-2" title="">
            <img class="avatar sm rounded-circle border" src="../../assets/img/xs/avatar4.jpg" alt="avatar">
            </a>
            <a class="nav-link rounded-circle p-1 mb-2" href="javascript:void(0);" data-bs-toggle="pill" data-bs-target="#c-user-1" title="">
            <img class="avatar sm rounded-circle border" src="../../assets/img/xs/avatar5.jpg" alt="avatar">
            </a>
            <a class="nav-link rounded-circle p-1 mb-2" href="javascript:void(0);" data-bs-toggle="pill" data-bs-target="#c-user-1" title="">
            <img class="avatar sm rounded-circle border" src="../../assets/img/xs/avatar6.jpg" alt="avatar">
            </a>
            <a class="nav-link rounded-circle p-1 mb-2" href="javascript:void(0);" data-bs-toggle="pill" data-bs-target="#c-user-2" title="">
            <img class="avatar sm rounded-circle border" src="../../assets/img/xs/avatar7.jpg" alt="avatar">
            </a>
            <a class="nav-link rounded-circle p-1 mb-2" href="javascript:void(0);" data-bs-toggle="pill" data-bs-target="#c-user-2" title="">
            <img class="avatar sm rounded-circle border" src="../../assets/img/xs/avatar8.jpg" alt="avatar">
            </a>
            <a class="nav-link rounded-circle p-1 mb-2" href="javascript:void(0);" data-bs-toggle="pill" data-bs-target="#c-user-3" title="">
            <img class="avatar sm rounded-circle border" src="../../assets/img/xs/avatar9.jpg" alt="avatar">
            </a>
        </div>
        <div class="tab-content shadow-sm order-0" style="width: calc(100% - 66px);">
            <div class="tab-pane card fade show active" id="c-user-1" role="tabpanel">
            <!-- start: chat header -->
            <div class="card-header border-bottom py-3 px-2">
                <div class="d-flex">
                <a href="javascript:void(0);" title="">
                    <img class="avatar rounded" src="../../assets/img/xs/avatar1.jpg" alt="avatar">
                </a>
                <div class="ms-3">
                    <h6 class="mb-0">Orlando Lentz</h6>
                    <small class="text-success">Online</small>
                </div>
                </div>
                <div class="dropdown morphing scale-left">
                <a class="nav-link p-2 text-secondary d-none d-xl-inline-block" href="javascript:void(0);"><i class="fa fa-camera"></i></a>
                <a class="nav-link p-2 me-1 text-secondary d-none d-xl-inline-block" href="javascript:void(0);"><i class="fa fa-video-camera"></i></a>
                <a class="nav-link py-2 px-3 text-muted d-inline-block d-xl-none" data-bs-dismiss="offcanvas" aria-label="Close" href="#"><i class="fa fa-close"></i></a>
                <a href="#" class="more-icon dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa fa-ellipsis-h"></i></a>
                <ul class="dropdown-menu shadow border-0 p-2">
                    <li><a class="dropdown-item" href="#">File Info</a></li>
                    <li><a class="dropdown-item" href="#">Copy to</a></li>
                    <li><a class="dropdown-item" href="#">Move to</a></li>
                    <li><a class="dropdown-item" href="#">Rename</a></li>
                    <li><a class="dropdown-item" href="#">Block</a></li>
                    <li><a class="dropdown-item" href="#">Delete</a></li>
                </ul>
                </div>
            </div>
            <!-- start: chat body -->
            <div class="card-body px-2 custom_scroll" style="height: calc(100vh - 148px);">
                <ul class="list-unstyled chat-history flex-grow-1">
                <!-- Chat: left -->
                <li class="mb-3 d-flex flex-row align-items-end">
                    <div class="max-width-70">
                    <div class="user-info mb-1">
                        <img class="avatar xs rounded me-1" src="../../assets/img/xs/avatar1.jpg" alt="avatar">
                        <span class="text-muted small">10:10 AM, Today</span>
                    </div>
                    <div class="card p-3">
                        <div class="message"> Hi Aiden, how are you?</div>
                    </div>
                    </div>
                    <!-- More option -->
                    <div class="btn-group">
                    <a href="#" class="nav-link py-2 px-3 text-muted" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa fa-ellipsis-v"></i></a>
                    <ul class="dropdown-menu rounded-4 border-0 shadow">
                        <li><a class="dropdown-item" href="#">Edit</a></li>
                        <li><a class="dropdown-item" href="#">Share</a></li>
                        <li><a class="dropdown-item" href="#">Delete</a></li>
                    </ul>
                    </div>
                </li>
                <!-- Chat: right -->
                <li class="mb-3 d-flex flex-row-reverse align-items-end">
                    <div class="max-width-70 text-end">
                    <div class="user-info mb-1">
                        <span class="text-muted small">10:12 AM, Today</span>
                    </div>
                    <div class="card border-0 p-3 bg-primary text-light">
                        <div class="message">Are we meeting today?</div>
                    </div>
                    </div>
                    <!-- More option -->
                    <div class="btn-group">
                    <a href="#" class="nav-link py-2 px-3 text-muted" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa fa-ellipsis-v"></i></a>
                    <ul class="dropdown-menu rounded-4 border-0 shadow">
                        <li><a class="dropdown-item" href="#">Edit</a></li>
                        <li><a class="dropdown-item" href="#">Share</a></li>
                        <li><a class="dropdown-item" href="#">Delete</a></li>
                    </ul>
                    </div>
                </li>
                <!-- Chat: left -->
                <li class="mb-3 d-flex flex-row align-items-end">
                    <div class="max-width-70">
                    <div class="user-info mb-1">
                        <img class="avatar xs rounded me-1" src="../../assets/img/xs/avatar1.jpg" alt="avatar">
                        <span class="text-muted small">10:10 AM, Today</span>
                    </div>
                    <div class="card p-3">
                        <div class="message"> It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.</div>
                    </div>
                    </div>
                    <!-- More option -->
                    <div class="btn-group">
                    <a href="#" class="nav-link py-2 px-3 text-muted" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa fa-ellipsis-v"></i></a>
                    <ul class="dropdown-menu rounded-4 border-0 shadow">
                        <li><a class="dropdown-item" href="#">Edit</a></li>
                        <li><a class="dropdown-item" href="#">Share</a></li>
                        <li><a class="dropdown-item" href="#">Delete</a></li>
                    </ul>
                    </div>
                </li>
                <!-- Chat: left -->
                <li class="mb-3 d-flex flex-row align-items-end">
                    <div class="max-width-70">
                    <div class="user-info mb-1">
                        <img class="avatar xs rounded me-1" src="../../assets/img/xs/avatar1.jpg" alt="avatar">
                        <span class="text-muted small">10:10 AM, Today</span>
                    </div>
                    <div class="card p-3">
                        <div class="message"> Contrary to popular belief, Lorem Ipsum is not simply random text.</div>
                    </div>
                    </div>
                    <!-- More option -->
                    <div class="btn-group">
                    <a href="#" class="nav-link py-2 px-3 text-muted" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa fa-ellipsis-v"></i></a>
                    <ul class="dropdown-menu rounded-4 border-0 shadow">
                        <li><a class="dropdown-item" href="#">Edit</a></li>
                        <li><a class="dropdown-item" href="#">Share</a></li>
                        <li><a class="dropdown-item" href="#">Delete</a></li>
                    </ul>
                    </div>
                </li>
                <!-- Chat: right -->
                <li class="mb-3 d-flex flex-row-reverse align-items-end">
                    <div class="max-width-70 text-end">
                    <div class="user-info mb-1">
                        <span class="text-muted small">10:12 AM, Today</span>
                    </div>
                    <div class="card border-0 p-3 bg-primary text-light">
                        <div class="message">Yes, Orlando Allredy done <br> There are many variations of passages of Lorem Ipsum available</div>
                    </div>
                    </div>
                    <!-- More option -->
                    <div class="btn-group">
                    <a href="#" class="nav-link py-2 px-3 text-muted" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa fa-ellipsis-v"></i></a>
                    <ul class="dropdown-menu rounded-4 border-0 shadow">
                        <li><a class="dropdown-item" href="#">Edit</a></li>
                        <li><a class="dropdown-item" href="#">Share</a></li>
                        <li><a class="dropdown-item" href="#">Delete</a></li>
                    </ul>
                    </div>
                </li>
                <!-- Chat: left -->
                <li class="mb-3 d-flex flex-row align-items-end">
                    <div class="max-width-70">
                    <div class="user-info mb-1">
                        <img class="avatar xs rounded me-1" src="../../assets/img/xs/avatar1.jpg" alt="avatar">
                        <span class="text-muted small">10:10 AM, Today</span>
                    </div>
                    <div class="card p-3">
                        <div class="message">
                        <p>Please find attached images</p>
                        <img class="w120 img-thumbnail" src="../../assets/img/gallery/3.jpg" alt="">
                        <img class="w120 img-thumbnail" src="../../assets/img/gallery/4.jpg" alt="">
                        </div>
                    </div>
                    </div>
                    <!-- More option -->
                    <div class="btn-group">
                    <a href="#" class="nav-link py-2 px-3 text-muted" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa fa-ellipsis-v"></i></a>
                    <ul class="dropdown-menu rounded-4 border-0 shadow">
                        <li><a class="dropdown-item" href="#">Edit</a></li>
                        <li><a class="dropdown-item" href="#">Share</a></li>
                        <li><a class="dropdown-item" href="#">Delete</a></li>
                    </ul>
                    </div>
                </li>
                <!-- Chat: right -->
                <li class="mb-3 d-flex flex-row-reverse align-items-end">
                    <div class="max-width-70 text-end">
                    <div class="user-info mb-1">
                        <span class="text-muted small">10:12 AM, Today</span>
                    </div>
                    <div class="card border-0 p-3 bg-primary text-light">
                        <div class="message">Okay, will check and let you know.</div>
                    </div>
                    </div>
                    <!-- More option -->
                    <div class="btn-group">
                    <a href="#" class="nav-link py-2 px-3 text-muted" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa fa-ellipsis-v"></i></a>
                    <ul class="dropdown-menu rounded-4 border-0 shadow">
                        <li><a class="dropdown-item" href="#">Edit</a></li>
                        <li><a class="dropdown-item" href="#">Share</a></li>
                        <li><a class="dropdown-item" href="#">Delete</a></li>
                    </ul>
                    </div>
                </li>
                </ul>
            </div>
            <!-- start: chat footer -->
            <div class="card-footer border-top bg-transparent py-3 px-2">
                <div class="input-group">
                <input type="text" class="form-control" placeholder="Enter text here...">
                <button class="btn btn-primary" type="button">Send</button>
                </div>
            </div>
            </div>
            <div class="tab-pane card fade" id="c-user-2" role="tabpanel">
            <!-- start: chat header -->
            <div class="card-header border-bottom py-3 px-2">
                <div class="d-flex">
                <a href="javascript:void(0);" title="">
                    <img class="avatar rounded" src="../../assets/img/xs/avatar2.jpg" alt="avatar">
                </a>
                <div class="ms-3">
                    <h6 class="mb-0">Issa Bell</h6>
                    <small class="text-muted">Last seen: 1 hours ago</small>
                </div>
                </div>
                <div class="dropdown morphing scale-left">
                <a class="nav-link p-2 text-secondary d-none d-xl-inline-block" href="javascript:void(0);"><i class="fa fa-camera"></i></a>
                <a class="nav-link p-2 me-1 text-secondary d-none d-xl-inline-block" href="javascript:void(0);"><i class="fa fa-video-camera"></i></a>
                <a class="nav-link py-2 px-3 text-muted d-inline-block d-xl-none" data-bs-dismiss="offcanvas" aria-label="Close" href="#"><i class="fa fa-close"></i></a>
                <a href="#" class="more-icon dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa fa-ellipsis-h"></i></a>
                <ul class="dropdown-menu shadow border-0 p-2">
                    <li><a class="dropdown-item" href="#">File Info</a></li>
                    <li><a class="dropdown-item" href="#">Copy to</a></li>
                    <li><a class="dropdown-item" href="#">Move to</a></li>
                    <li><a class="dropdown-item" href="#">Rename</a></li>
                    <li><a class="dropdown-item" href="#">Block</a></li>
                    <li><a class="dropdown-item" href="#">Delete</a></li>
                </ul>
                </div>
            </div>
            <!-- start: chat body -->
            <div class="card-body px-2 custom_scroll" style="height: calc(100vh - 148px);">
                <ul class="list-unstyled chat-history flex-grow-1">
                <!-- Chat: right -->
                <li class="mb-3 d-flex flex-row-reverse align-items-end">
                    <div class="max-width-70 text-end">
                    <div class="user-info mb-1">
                        <span class="text-muted small">10:12 AM, Today</span>
                    </div>
                    <div class="card border-0 p-3 bg-primary text-light">
                        <div class="message">Are we meeting today?</div>
                    </div>
                    </div>
                    <!-- More option -->
                    <div class="btn-group">
                    <a href="#" class="nav-link py-2 px-3 text-muted" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa fa-ellipsis-v"></i></a>
                    <ul class="dropdown-menu rounded-4 border-0 shadow">
                        <li><a class="dropdown-item" href="#">Edit</a></li>
                        <li><a class="dropdown-item" href="#">Share</a></li>
                        <li><a class="dropdown-item" href="#">Delete</a></li>
                    </ul>
                    </div>
                </li>
                <!-- Chat: left -->
                <li class="mb-3 d-flex flex-row align-items-end">
                    <div class="max-width-70">
                    <div class="user-info mb-1">
                        <img class="avatar xs rounded me-1" src="../../assets/img/xs/avatar2.jpg" alt="avatar">
                        <span class="text-muted small">10:10 AM, Today</span>
                    </div>
                    <div class="card p-3">
                        <div class="message"> Hi Aiden, how are you?</div>
                    </div>
                    </div>
                    <!-- More option -->
                    <div class="btn-group">
                    <a href="#" class="nav-link py-2 px-3 text-muted" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa fa-ellipsis-v"></i></a>
                    <ul class="dropdown-menu rounded-4 border-0 shadow">
                        <li><a class="dropdown-item" href="#">Edit</a></li>
                        <li><a class="dropdown-item" href="#">Share</a></li>
                        <li><a class="dropdown-item" href="#">Delete</a></li>
                    </ul>
                    </div>
                </li>
                <!-- Chat: right -->
                <li class="mb-3 d-flex flex-row-reverse align-items-end">
                    <div class="max-width-70 text-end">
                    <div class="user-info mb-1">
                        <span class="text-muted small">10:12 AM, Today</span>
                    </div>
                    <div class="card border-0 p-3 bg-primary text-light">
                        <div class="message">Yes, Orlando Allredy done <br> There are many variations of passages of Lorem Ipsum available</div>
                    </div>
                    </div>
                    <!-- More option -->
                    <div class="btn-group">
                    <a href="#" class="nav-link py-2 px-3 text-muted" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa fa-ellipsis-v"></i></a>
                    <ul class="dropdown-menu rounded-4 border-0 shadow">
                        <li><a class="dropdown-item" href="#">Edit</a></li>
                        <li><a class="dropdown-item" href="#">Share</a></li>
                        <li><a class="dropdown-item" href="#">Delete</a></li>
                    </ul>
                    </div>
                </li>
                <!-- Chat: left -->
                <li class="mb-3 d-flex flex-row align-items-end">
                    <div class="max-width-70">
                    <div class="user-info mb-1">
                        <img class="avatar xs rounded me-1" src="../../assets/img/xs/avatar2.jpg" alt="avatar">
                        <span class="text-muted small">10:10 AM, Today</span>
                    </div>
                    <div class="card p-3">
                        <div class="message">
                        <p>Please find attached images</p>
                        <img class="w120 img-thumbnail" src="../../assets/img/gallery/1.jpg" alt="">
                        <img class="w120 img-thumbnail" src="../../assets/img/gallery/2.jpg" alt="">
                        </div>
                    </div>
                    </div>
                    <!-- More option -->
                    <div class="btn-group">
                    <a href="#" class="nav-link py-2 px-3 text-muted" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa fa-ellipsis-v"></i></a>
                    <ul class="dropdown-menu rounded-4 border-0 shadow">
                        <li><a class="dropdown-item" href="#">Edit</a></li>
                        <li><a class="dropdown-item" href="#">Share</a></li>
                        <li><a class="dropdown-item" href="#">Delete</a></li>
                    </ul>
                    </div>
                </li>
                <!-- Chat: right -->
                <li class="mb-3 d-flex flex-row-reverse align-items-end">
                    <div class="max-width-70 text-end">
                    <div class="user-info mb-1">
                        <span class="text-muted small">10:12 AM, Today</span>
                    </div>
                    <div class="card border-0 p-3 bg-primary text-light">
                        <div class="message">Okay, will check and let you know.</div>
                    </div>
                    </div>
                    <!-- More option -->
                    <div class="btn-group">
                    <a href="#" class="nav-link py-2 px-3 text-muted" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa fa-ellipsis-v"></i></a>
                    <ul class="dropdown-menu rounded-4 border-0 shadow">
                        <li><a class="dropdown-item" href="#">Edit</a></li>
                        <li><a class="dropdown-item" href="#">Share</a></li>
                        <li><a class="dropdown-item" href="#">Delete</a></li>
                    </ul>
                    </div>
                </li>
                <!-- Chat: left -->
                <li class="mb-3 d-flex flex-row align-items-end">
                    <div class="max-width-70">
                    <div class="user-info mb-1">
                        <img class="avatar xs rounded me-1" src="../../assets/img/xs/avatar2.jpg" alt="avatar">
                        <span class="text-muted small">10:10 AM, Today</span>
                    </div>
                    <div class="card p-3">
                        <div class="message"> It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.</div>
                    </div>
                    </div>
                    <!-- More option -->
                    <div class="btn-group">
                    <a href="#" class="nav-link py-2 px-3 text-muted" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa fa-ellipsis-v"></i></a>
                    <ul class="dropdown-menu rounded-4 border-0 shadow">
                        <li><a class="dropdown-item" href="#">Edit</a></li>
                        <li><a class="dropdown-item" href="#">Share</a></li>
                        <li><a class="dropdown-item" href="#">Delete</a></li>
                    </ul>
                    </div>
                </li>
                <!-- Chat: left -->
                <li class="mb-3 d-flex flex-row align-items-end">
                    <div class="max-width-70">
                    <div class="user-info mb-1">
                        <img class="avatar xs rounded me-1" src="../../assets/img/xs/avatar2.jpg" alt="avatar">
                        <span class="text-muted small">10:10 AM, Today</span>
                    </div>
                    <div class="card p-3">
                        <div class="message"> Contrary to popular belief, Lorem Ipsum is not simply random text.</div>
                    </div>
                    </div>
                    <!-- More option -->
                    <div class="btn-group">
                    <a href="#" class="nav-link py-2 px-3 text-muted" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa fa-ellipsis-v"></i></a>
                    <ul class="dropdown-menu rounded-4 border-0 shadow">
                        <li><a class="dropdown-item" href="#">Edit</a></li>
                        <li><a class="dropdown-item" href="#">Share</a></li>
                        <li><a class="dropdown-item" href="#">Delete</a></li>
                    </ul>
                    </div>
                </li>
                </ul>
            </div>
            <!-- start: chat footer -->
            <div class="card-footer border-top bg-transparent py-3 px-2">
                <div class="input-group">
                <input type="text" class="form-control" placeholder="Enter text here...">
                <button class="btn btn-primary" type="button">Send</button>
                </div>
            </div>
            </div>
            <div class="tab-pane card fade" id="c-user-3" role="tabpanel">
            <!-- start: chat header -->
            <div class="card-header border-bottom py-3 px-2">
                <div class="d-flex">
                <a href="javascript:void(0);" title="">
                    <img class="avatar rounded" src="../../assets/img/xs/avatar9.jpg" alt="avatar">
                </a>
                <div class="ms-3">
                    <h6 class="mb-0">Dean Otto</h6>
                    <small class="text-muted">Last seen: 2 hours ago</small>
                </div>
                </div>
                <div class="dropdown morphing scale-left">
                <a class="nav-link p-2 text-secondary d-none d-xl-inline-block" href="javascript:void(0);"><i class="fa fa-camera"></i></a>
                <a class="nav-link p-2 me-1 text-secondary d-none d-xl-inline-block" href="javascript:void(0);"><i class="fa fa-video-camera"></i></a>
                <a class="nav-link py-2 px-3 text-muted d-inline-block d-xl-none" data-bs-dismiss="offcanvas" aria-label="Close" href="#"><i class="fa fa-close"></i></a>
                <a href="#" class="more-icon dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa fa-ellipsis-h"></i></a>
                <ul class="dropdown-menu shadow border-0 p-2">
                    <li><a class="dropdown-item" href="#">File Info</a></li>
                    <li><a class="dropdown-item" href="#">Copy to</a></li>
                    <li><a class="dropdown-item" href="#">Move to</a></li>
                    <li><a class="dropdown-item" href="#">Rename</a></li>
                    <li><a class="dropdown-item" href="#">Block</a></li>
                    <li><a class="dropdown-item" href="#">Delete</a></li>
                </ul>
                </div>
            </div>
            <!-- start: chat body -->
            <div class="card-body px-2 custom_scroll" style="height: calc(100vh - 148px);">
                <ul class="list-unstyled chat-history flex-grow-1">
                <!-- Chat: right -->
                <li class="mb-3 d-flex flex-row-reverse align-items-end">
                    <div class="max-width-70 text-end">
                    <div class="user-info mb-1">
                        <span class="text-muted small">10:12 AM, Today</span>
                    </div>
                    <div class="card border-0 p-3 bg-primary text-light">
                        <div class="message">Are we meeting today?</div>
                    </div>
                    </div>
                    <!-- More option -->
                    <div class="btn-group">
                    <a href="#" class="nav-link py-2 px-3 text-muted" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa fa-ellipsis-v"></i></a>
                    <ul class="dropdown-menu rounded-4 border-0 shadow">
                        <li><a class="dropdown-item" href="#">Edit</a></li>
                        <li><a class="dropdown-item" href="#">Share</a></li>
                        <li><a class="dropdown-item" href="#">Delete</a></li>
                    </ul>
                    </div>
                </li>
                </ul>
            </div>
            <!-- start: chat footer -->
            <div class="card-footer border-top bg-transparent py-3 px-2">
                <div class="input-group">
                <input type="text" class="form-control" placeholder="Enter text here...">
                <button class="btn btn-primary" type="button">Send</button>
                </div>
            </div>
            </div>
        </div>
        </div>
    </div>
</template>
  
<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import { hasRole, getCurrentUser } from '@/api/auth';
import { isMenuVisible } from '@/api/menus';

const AKUN_SAYA_ITEM = {
    menu:"Akun Saya",
    svg:'<svg xmlns="http://www.w3.org/2000/svg" width="18" fill="currentColor" viewBox="0 0 16 16"><path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm2 1H6a3 3 0 0 0-3 3v1h10v-1a3 3 0 0 0-3-3Z" /></svg>',
    sub : [
        {
            name:'Akun Saya',
        },
    ]
};

const BUSINESS_MENU_KODE = {
    'Nasabah': 'nasabah',
    'Master Sampah': 'master-sampah',
    'Transaksi Setoran': 'transaksi-setoran',
    'Penarikan': 'penarikan',
    'Penyesuaian Saldo': 'penyesuaian-saldo',
    'Penjualan Sampah': 'penjualan-sampah',
    'Kas': 'kas',
    'Laporan': 'laporan',
    'Pengumuman': 'pengumuman',
};
  export default {
    name: 'SidebarComponent',
    components: {
        'datepicker':VueDatePicker
    },
    data () {
        return{
            sidebarMenuItems:null,
            domain:null,
            picked: {
                date:new Date(),
                time:''
            }
        }
    },
    methods:{
        async reloadSidebar(){
            this.sidebarMenuItems = [];
            let domain = await this.$route.meta.domain;
            if(domain == 'Admin'){
                const roles = getCurrentUser()?.roles || [];
                // Nasabah murni (tanpa role staff lain) cuma dapat menu "Akun Saya".
                const isPureNasabah = roles.length > 0 && roles.every((r) => r === 'nasabah');
                if (isPureNasabah) {
                    this.sidebarMenuItems = [AKUN_SAYA_ITEM];
                    return;
                }
                this.sidebarMenuItems = [
                    {
                        menu:"My Dashboard",
                        svg:'<svg xmlns="http://www.w3.org/2000/svg" width="18" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6zm5-.793V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z" /><path class="var(--secondary-color)" fill-rule="evenodd" d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z" /></svg>',
                        sub : [
                            {
                                name:'Bank Sampah Dashboard',
                            },
                        ]
                    },
                    {
                        menu:"Nasabah",
                        svg:'<svg xmlns="http://www.w3.org/2000/svg" width="18" fill="currentColor" viewBox="0 0 16 16"><path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8Zm-7.978-1A.261.261 0 0 1 7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002a.274.274 0 0 1-.014.002H7.022ZM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816ZM4.92 10A5.493 5.493 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275ZM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z" /></svg>',
                        sub : [
                            {
                                name:'Nasabah List',
                            },
                            {
                                name:'Registrasi Nasabah List',
                            },
                        ]
                    },
                    {
                        menu:"Master Sampah",
                        svg:'<svg xmlns="http://www.w3.org/2000/svg" width="18" fill="currentColor" viewBox="0 0 16 16"><path d="M9.669.864 8 0 6.331.864l-1.858.282-.842 1.68-1.337 1.32L2.6 6l-.306 1.854 1.337 1.32.842 1.68 1.858.282L8 12l1.669-.864 1.858-.282.842-1.68 1.337-1.32L13.4 6l.306-1.854-1.337-1.32-.842-1.68L9.669.864Zm1.196 1.193.684 1.365 1.086 1.072L12.4 6l.235 1.506-1.086 1.072-.684 1.365-1.51.229L8 10.874l-1.355-.702-1.51-.229-.684-1.365-1.086-1.072L3.6 6l-.235-1.506 1.086-1.072.684-1.365 1.51-.229L8 1.126l1.355.702 1.51.229ZM4 11v3.5a.5.5 0 0 0 .78.415L8 12.788l3.22 2.127A.5.5 0 0 0 12 14.5V11h-1v2.566l-2.72-1.798a.5.5 0 0 0-.56 0L5 13.566V11H4Z" /></svg>',
                        sub : [
                            {
                                name:'Master Sampah List',
                            },
                        ]
                    },
                    {
                        menu:"Transaksi Setoran",
                        svg:'<svg xmlns="http://www.w3.org/2000/svg" width="18" fill="currentColor" viewBox="0 0 16 16"><path d="M9.5 6.5a.5.5 0 0 1-.5.5H2a.5.5 0 0 1 0-1h7a.5.5 0 0 1 .5.5Zm0 3a.5.5 0 0 1-.5.5H2a.5.5 0 0 1 0-1h7a.5.5 0 0 1 .5.5Zm-6-6a.5.5 0 0 1-.5.5H2a.5.5 0 0 1 0-1h1a.5.5 0 0 1 .5.5ZM1 2.5A1.5 1.5 0 0 1 2.5 1h11A1.5 1.5 0 0 1 15 2.5v11a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 13.5v-11ZM2.5 2a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-11a.5.5 0 0 0-.5-.5h-11Z" /><path class="fill-secondary" d="M11.5 5.5a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Z" /></svg>',
                        sub : [
                            {
                                name:'Transaksi Setoran List',
                            },
                            {
                                name:'Transaksi Setoran Create',
                            },
                        ]
                    },
                    {
                        menu:"Penarikan",
                        svg:'<svg xmlns="http://www.w3.org/2000/svg" width="18" fill="currentColor" viewBox="0 0 16 16"><path d="M0 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2H0Zm0 2h16v6a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5Zm3 3.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 0-1h-2a.5.5 0 0 0-.5.5ZM9 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z" /></svg>',
                        sub : [
                            {
                                name:'Penarikan List',
                            },
                            {
                                name:'Penarikan Create',
                            },
                            {
                                name:'Penarikan Pengajuan List',
                            },
                        ]
                    },
                    {
                        menu:"Penyesuaian Saldo",
                        svg:'<svg xmlns="http://www.w3.org/2000/svg" width="18" fill="currentColor" viewBox="0 0 16 16"><path d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1Z" /><path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466Z" /></svg>',
                        sub : [
                            {
                                name:'Penyesuaian Saldo List',
                            },
                            {
                                name:'Penyesuaian Saldo Create',
                            },
                        ]
                    },
                    {
                        menu:"Penjualan Sampah",
                        svg:'<svg xmlns="http://www.w3.org/2000/svg" width="18" fill="currentColor" viewBox="0 0 16 16"><path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5ZM3.102 4l1.313 7h8.17l1.313-7H3.102ZM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z" /></svg>',
                        sub : [
                            {
                                name:'Penjualan Sampah List',
                            },
                            {
                                name:'Penjualan Sampah Create',
                            },
                        ]
                    },
                    {
                        menu:"Kas",
                        svg:'<svg xmlns="http://www.w3.org/2000/svg" width="18" fill="currentColor" viewBox="0 0 16 16"><path d="M0 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3Zm1 1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1Zm1-2a1 1 0 0 0-1 1h14a1 1 0 0 0-1-1H2Z" /><path class="fill-secondary" d="M8 6a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z" /></svg>',
                        sub : [
                            {
                                name:'Kas Ringkasan',
                            },
                        ]
                    },
                    {
                        menu:"Laporan",
                        svg:'<svg xmlns="http://www.w3.org/2000/svg" width="18" fill="currentColor" viewBox="0 0 16 16"><path d="M4 11H2v3h2v-3Zm5-4H7v7h2V7Zm5-5h-2v12h2V2ZM1 8v6H0V8h1Zm5-3v9H5V5h1Zm5-4v13h-1V1h1Z" /></svg>',
                        sub : [
                            {
                                name:'Laporan Nasabah',
                            },
                            {
                                name:'Laporan Sampah',
                            },
                            {
                                name:'Laporan Keuangan',
                            },
                        ]
                    },
                    {
                        menu:"Pengumuman",
                        svg:'<svg xmlns="http://www.w3.org/2000/svg" width="18" fill="currentColor" viewBox="0 0 16 16"><path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2ZM8 1.918l-.797.161A4.002 4.002 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4.002 4.002 0 0 0-3.203-3.92L8 1.917ZM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5.002 5.002 0 0 1 13 6c0 .88.32 4.2 1.22 6Z" /></svg>',
                        sub : [
                            {
                                name:'Pengumuman List',
                            },
                        ]
                    },
                ];
                this.sidebarMenuItems = this.sidebarMenuItems.filter((item) => {
                    const kode = BUSINESS_MENU_KODE[item.menu];
                    return !kode || isMenuVisible(kode, roles);
                });
                // Staff yang juga nasabah (mis. admin+nasabah) tetap dapat menu
                // "Akun Saya" untuk mengelola saldo/penarikan miliknya sendiri.
                if (roles.includes('nasabah')) {
                    this.sidebarMenuItems.push(AKUN_SAYA_ITEM);
                }
                if (hasRole('superadmin')) {
                    this.sidebarMenuItems.push({
                        menu:"User Management",
                        svg:'<svg xmlns="http://www.w3.org/2000/svg" width="18" fill="currentColor" viewBox="0 0 16 16"><path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8Zm-7.978-1A.261.261 0 0 1 7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002a.274.274 0 0 1-.014.002H7.022ZM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816ZM4.92 10A5.493 5.493 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275ZM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z" /></svg>',
                        sub : [
                            {
                                name:'User Management List',
                            },
                            {
                                name:'Menu Management List',
                            },
                            {
                                name:'Role Management List',
                            },
                        ]
                    });
                    this.sidebarMenuItems.push({
                        menu:"Audit Trail List",
                        svg:'<svg xmlns="http://www.w3.org/2000/svg" width="18" fill="currentColor" viewBox="0 0 16 16"><path d="M8.5 4.5a.5.5 0 0 0-1 0v4a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 0-1H8.5v-3.5z"/><path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1z"/></svg>',
                    });
                }
            }
        },
        hideSidebar(){
            document.getElementById('sidebar').classList.remove('open');
        }
    },
    async mounted(){
        await this.reloadSidebar();
        this.emitter.on('menus-updated', this.reloadSidebar);
    },
    async created(){
        await this.reloadSidebar();
    },
    computed: {
        currentRoutePath() {
            return this.$route.name;
        },
        currentTab() {
            return this.$route?.matched[0]?.name;
        },
    },
    watch: {
        $route() {
           this.reloadSidebar();
           this.hideSidebar()
        },
    },
  }
</script>
  